function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-20.000000, -24.000000)",
  fill: "#257FE8",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Navigation"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header",
  transform: "translate(20.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo?"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 20,
  cy: 20,
  r: 6.66666667
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,0 C8.955,0 0,8.955 0,20 C0,31.0465 8.955,40 20,40 C31.0465,40 40,31.0465 40,20 C40,8.955 31.0465,0 20,0 Z M29.525,22.49975 C35.475708,29.1164551 29.99975,35 20,35 C11.714,35 5,28.286 5,20 C5,11.714 11.714,5 20,5 C27.43175,5 35.475708,9.50146484 29.525,17.50025 C27.2107666,18.6192253 26.0536499,19.4524753 26.0536499,20 C26.0536499,20.5634753 27.2107666,21.3967253 29.525,22.49975 Z",
  id: "Shape"
}))))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.64fe8c7a.svg";
export { ForwardRef as ReactComponent };